import { NonIdealState } from "components";

export const ListaVazia = () => <NonIdealState
	icon="survey"
	title="Nada por aqui"
	description="Você ainda não realizou nenhuma contribuição."
	color="var(--Branding-Color)"
/>
